import { render, staticRenderFns } from "./LocalOcorrenciaNascimentoSV.vue?vue&type=template&id=b7a1144e&scoped=true&"
import script from "./LocalOcorrenciaNascimentoSV.vue?vue&type=script&lang=js&"
export * from "./LocalOcorrenciaNascimentoSV.vue?vue&type=script&lang=js&"
import style0 from "./LocalOcorrenciaNascimentoSV.vue?vue&type=style&index=0&id=b7a1144e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a1144e",
  null
  
)

export default component.exports